// src/App.jsx
import PDFViewer from './components/PDFViewer/PDFViewer.jsx';
import { useEffect } from 'react';
function isAppleSystem() {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // 检测是否为 iOS 设备（iPhone、iPad、iPod）
    if (/iPad|iPhone|iPod/.test(userAgent)) {
        return true;
    }

    // 检测是否为 macOS（排除 Chrome 和 Firefox 等非 Safari 浏览器的干扰）
    if (/Macintosh/.test(userAgent) && !window.chrome && !window.opera && !navigator.userAgent.includes('Edge')) {
        return true;
    }

    // 更宽松的 macOS 判断（只要求包含 Macintosh）
    // if (/Macintosh/.test(userAgent)) {
    //     return true;
    // }

    return false;
}
function App() {
  useEffect(() => {
    if (isAppleSystem()) {
      // 直接跳转到https://www.chembeango.cn/cbg_index_image/statics/app/pro-introdution.pdf
      window.location.href = 'https://www.chembeango.cn/cbg_index_image/statics/app/pro-introdution.pdf';
      return;
    }
  }, [])
  

  return (
    <div className="app">
      <PDFViewer file='https://www.chembeango.cn/cbg_index_image/statics/app/pro-introdution.pdf' />
    </div>
  );
}

export default App;